var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#003485"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 73.9751H60.0258M47.5999 85.4095H72.3999C75.2935 85.4095 76.7403 85.4095 77.8455 84.8556C78.8177 84.3684 79.6081 83.591 80.1035 82.6347C80.6666 81.5476 80.6666 80.1245 80.6666 77.2784V42.721C80.6666 39.8748 80.6666 38.4517 80.1035 37.3646C79.6081 36.4084 78.8177 35.631 77.8455 35.1437C76.7403 34.5898 75.2935 34.5898 72.3999 34.5898H47.5999C44.7063 34.5898 43.2595 34.5898 42.1543 35.1437C41.1821 35.631 40.3917 36.4084 39.8964 37.3646C39.3333 38.4517 39.3333 39.8748 39.3333 42.721V77.2784C39.3333 80.1245 39.3333 81.5476 39.8964 82.6347C40.3917 83.591 41.1821 84.3684 42.1543 84.8556C43.2595 85.4095 44.7063 85.4095 47.5999 85.4095ZM61.2916 73.9751C61.2916 74.6768 60.7133 75.2456 59.9999 75.2456C59.2866 75.2456 58.7083 74.6768 58.7083 73.9751C58.7083 73.2734 59.2866 72.7046 59.9999 72.7046C60.7133 72.7046 61.2916 73.2734 61.2916 73.9751Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOtp);
export default __webpack_public_path__ + "static/media/mobile-otp.48a970f1ade7bcf9efef35e607c87470.svg";
export { ForwardRef as ReactComponent };